import { withParams } from 'vuelidate/lib';

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export default withParams({ type: 'uuid' }, (value) => {
  if (!value) {
    return true;
  }

  return UUID_REGEX.test(value);
});
